import { EnumDataType, EnumDataTypeMD } from '../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { PlatDataType } from '../../../../../api/com/MetaPattern/Core/Infrastructure/Common/PlatDataType';
import { BaseElement } from '../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { Dictionary } from '../../Product/IDE/Util/Dictionary';
import { TreeNode } from '../../Product/IDE/Util/TreeNode';

export class DataTypeManager {
  private static _instance = new DataTypeManager();
  private _primitiveTypes: Dictionary<string, PlatDataType>; // 简单类型<name, type>
  private _platDataTypes: Array<TreeNode<BaseElement>>;

  private constructor() {
    this._primitiveTypes = new Dictionary<string, PlatDataType>();
    this._primitiveTypes.append('Bool', this.createPrimitiveType('Bool', 'bool', false, 'false', EnumDataType.Bool));
    this._primitiveTypes.append('DateTime', this.createPrimitiveType('DateTime', 'DateTime', true, null, EnumDataType.DateTime));
    this._primitiveTypes.append('Date', this.createPrimitiveType('Date', 'Date', true, null, EnumDataType.Date));
    this._primitiveTypes.append('Double', this.createPrimitiveType('Double', 'double', false, '0', EnumDataType.Double));
    this._primitiveTypes.append('Float', this.createPrimitiveType('Float', 'float', false, '0', EnumDataType.Float));
    this._primitiveTypes.append('Guid', this.createPrimitiveType('Guid', 'guid', true, null, EnumDataType.Guid));
    this._primitiveTypes.append('Short', this.createPrimitiveType('Short', 'short', false, '0', EnumDataType.Short));
    this._primitiveTypes.append('Int', this.createPrimitiveType('Int', 'int', false, '0', EnumDataType.Int));
    this._primitiveTypes.append('Long', this.createPrimitiveType('Long', 'long', false, '0', EnumDataType.Long));
    this._primitiveTypes.append('Text', this.createPrimitiveType('Text', 'text', true, '', EnumDataType.Text));
    this._primitiveTypes.append('Money', this.createPrimitiveType('Money', 'money', false, '0', EnumDataType.Money));
    this._primitiveTypes.append('Richtext', this.createPrimitiveType('Richtext', 'richtext', true, '', EnumDataType.Richtext));
    this._primitiveTypes.append('String', this.createPrimitiveType('String', 'string', true, '', EnumDataType.String));
    this._primitiveTypes.append('UniqueKey', this.createPrimitiveType('UniqueKey', 'UniqueKey', true, null, EnumDataType.UniqueKey));
    this._primitiveTypes.append('Reference', this.createPrimitiveType('Reference', 'Reference', true, null, EnumDataType.Reference));
    this._platDataTypes = new Array<TreeNode<BaseElement>>();
    this._platDataTypes.push(new TreeNode<BaseElement>('void', 'void(无返回值)', 'void', true, null));
    // this._platDataTypes.push(new TreeNode<BaseElement>(EnumDataType.UniqueKey.toString(), `${EnumDataTypeMD.getItemByValue(EnumDataType.UniqueKey).name}(${EnumDataTypeMD.getItemByValue(EnumDataType.UniqueKey).displayName})`, 'UniqueKey', true, null));
    this._platDataTypes.push(new TreeNode<BaseElement>('Pagination', 'Pagination(分页条件)', 'Pagination', true, null));
    this._platDataTypes.push(new TreeNode<BaseElement>('Condition', 'Condition(查询条件)', 'Condition', true, null));
  }

  // 获取唯一实例
  public static get instance() {
    return this._instance;
  }

  // 根据全名获取数据类型，不存在则返回null
  // TODO: 复杂类型需要添加处理
  public getDataType(fullname: string): PlatDataType | null {
    if (this._primitiveTypes.contains(fullname)) {
      return this._primitiveTypes.getValue(fullname);
    }
    return null;
  }

  /**
   * 获取平台数据类型的树节点
   */
  public getPlatDataTypes() {
    return this._platDataTypes;
  }

  // 根据简称获取数据类型，不存在则返回null
  // TODO: 复杂类型需要添加处理
  public getDataTypeByAlias(alias: string): PlatDataType | null {
    const find = this._primitiveTypes.Entries.find(item => item.value.alias === alias);
    if (find) {
      return find.value;
    }
    return null;
  }

  // 根据类型枚举获取简单数据类型，不存在则返回null
  public getPrimitiveType(dataTypeEnum: EnumDataType): PlatDataType | null {
    const find = this._primitiveTypes.Entries.find(item => item.value.dataTypeEnum === dataTypeEnum);
    if (find) {
      return find.value;
    }
    return null;
  }

  // 判断是否是简单类型
  public isPrimitiveType(fullname: string) {
    if (this._primitiveTypes.contains(fullname)) {
      return true;
    }
    return false;
  }

  // 判断数据类型是否可空，引用类型都可以为空
  public isNullable(dataTypeEnum: EnumDataType): boolean {
    const dataType = this.getPrimitiveType(dataTypeEnum);
    if (dataType !== null) {
      return dataType.isNullable;
    }
    return true;
  }

  // 获取类型对象，只针对简单类型
  private createPrimitiveType(name: string, alias: string, isNullable: boolean, defaultValue: string, dataTypeEnum: EnumDataType): PlatDataType {
    const dataType = new PlatDataType();
    dataType.name = name;
    dataType.alias = alias;
    dataType.isNullable = isNullable;
    dataType.defaultValue = defaultValue;
    dataType.dataTypeEnum = dataTypeEnum;
    dataType.fullname = name;
    dataType.isPrimitive = true;

    return dataType;
  }
}
